import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PaymentOrderInvoice  {
    _originalTypeClassName = "zERP.BO.PaymentOrderInvoice";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PaymentOrderInvoice.translate = translateService;
}
this.Invoice = new Domain.AadeBookInvoiceType();
this.Details = [];
this.Id = null;
this.Amount = null;
this.Expanded = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Amount:any;
Expanded:any;
Invoice:any;
PaymentOrder:any;
Details:any;
static setInvoice = ($this, value) => {
var oldValue = $this.Invoice;
$this.Invoice = value;
if (value != null) {
if (oldValue != null) {
Domain.AadeBookInvoiceType.removePaymentOrderInvoices(oldValue, $this);
}
Domain.AadeBookInvoiceType.addPaymentOrderInvoices(value, $this);
}
}
static setPaymentOrder = ($this, value) => {
var oldValue = $this.PaymentOrder;
$this.PaymentOrder = value;
if (value != null) {
if (oldValue != null) {
Domain.PaymentOrder.removeDocuments(oldValue, $this);
}
Domain.PaymentOrder.addDocuments(value, $this);
}
}
static setDetails = ($this, items) => {
                if (items == null) items = [];
                if ($this.Details == null) $this.Details = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Details.length > 0) {
                    Domain.PaymentOrderInvoice.removeDetails($this, $this.Details[0]);
                }

                Domain.PaymentOrderInvoice.addManyDetails($this, copyItems);
            }
static addManyDetails = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.PaymentOrderInvoice.addDetails($this, items[i]);
                }
            }
static addDetails = ($this, item) => {
                if ($this.Details == null) $this.Details = [];
                if (item == null || $this.Details.indexOf(item) > -1) return;
                $this.Details.push(item);
if (item.PaymentOrderInvoice != $this) {
Domain.PaymentOrderDetail.setPaymentOrderInvoice(item, $this);
}
}
static addRangeDetails = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.PaymentOrderInvoice.addDetails($this, item));
            }
static removeDetails = ($this, item) => {
                if ($this == null || $this.Details == null || $this.Details.indexOf(item) === -1) return;
                var _index = $this.Details.indexOf(item);
                $this.Details.splice(_index, 1);
item.PaymentOrderInvoice = null;
}
static clearDetails = ($this) => { $this.Details = null; }

static AutofillAmount($this: any): any{$this.Amount = Domain.PaymentOrderInvoice.GetRemainingAmount($this);
}
static GetRemainingAmount($this: any): any{return Joove.Common.safeNumber($this?.Invoice?.InvoiceSummary?.TotalGrossValue) - Joove.Common.safeNumber($this?.Invoice?.PaidAmount) - Joove.Common.safeNumber($this?.Invoice?.CreditAmount);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}